import { createClient, ClientContextProvider as CCP } from 'react-fetching-library';
import { API_URL } from 'config/constant'
const requestHostInterceptor = (host: any) => (client: any) => async (action: any) => {
  return {
    ...action,
    endpoint: `${host}${action.endpoint}`,
  };
};

const clientOption = createClient({
  requestInterceptors: [requestHostInterceptor(API_URL)],
});

export const client = clientOption;

export const ClientContextProvider = CCP;
